// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__T0n5H","content":"styles_content__i67ZX","checkbox":"styles_checkbox__HNY7_","checkboxLabel":"styles_checkboxLabel__bdkYn"};